import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-col-10-padding position-relative" }
const _hoisted_2 = {
  key: 1,
  class: "customRouteTimePickerComponentContent"
}
const _hoisted_3 = {
  key: 0,
  class: "input-time-position"
}
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_google_autocomplete = _resolveComponent("vue-google-autocomplete")!
  const _component_CustomRouteTimePickerComponent = _resolveComponent("CustomRouteTimePickerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue_google_autocomplete, {
      class: "custom-route-input",
      classname: "form-control",
      country: "lt",
      types: "",
      ref: 'address' + _ctx.id,
      placeholder: _ctx.placeHolder,
      id: 'map' + _ctx.id,
      onInputChange: _ctx.getChange,
      onPlacechanged: _ctx.getAddressData
    }, null, 8, ["placeholder", "id", "onInputChange", "onPlacechanged"]),
    _createElementVNode("div", {
      class: _normalizeClass(["position-absolute d-flex align-items-center", {'icon-x-position': _ctx.arrivalTime, 'icon-xx-position': !_ctx.arrivalTime}])
    }, [
      (_ctx.index)
        ? (_openBlock(), _createBlock(_component_CustomRouteTimePickerComponent, {
            key: 0,
            "arrival-time": _ctx.arrivalTime,
            onGetCustomArrivalTime: _ctx.getArrivalTime
          }, null, 8, ["arrival-time", "onGetCustomArrivalTime"]))
        : _createCommentVNode("", true),
      (!_ctx.index)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.arrivalTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.arrivalTime.split(':')[0].trim() + ':' + _ctx.arrivalTime.split(':')[1].trim()), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRemovable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteRoute', _ctx.id))),
              src: "/assets/images/x-times.svg",
              alt: "delete route",
              srcset: ""
            })
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}